jQuery(document).ready(function ($) {
	// Play Lottie for the first active tab on page load
	var $firstActive = $(
		".wp-block-understrap-tab-item.tab-pane.show.active lottie-player",
	);
	if ($firstActive.length) {
		console.log("Playing Lottie for first active tab");
		$firstActive[0].stop();
		$firstActive[0].play();
	}

	// When a tab is shown (clicked)
	$('.wp-block-understrap-tabs [role="tab"]').on("shown.bs.tab", function (e) {
		var targetId = $(e.target).attr("aria-controls"); // get the tab content ID
		var $pane = $("#" + targetId);
		var $lottie = $pane.find("lottie-player");

		var tabName = $pane.data("tab-title") || "Unknown Tab";
		console.log("Tab clicked:", tabName);

		if ($lottie.length) {
			console.log("Stopping Lottie in tab:", tabName);
			$lottie[0].stop(); // stop/reset the animation
			console.log("Playing Lottie in tab:", tabName);
			$lottie[0].play(); // play fresh
		}
	});
	$(".wp-block-understrap-tabs").each(function () {
		var $section = $(this);
		var $navTabs = $section.find(".nav-tabs");
		var $navLinks = $navTabs.find(".nav-item .nav-link");
		var $tabPanes = $section.find(".tab-pane");
		var currentIndex = $navLinks.filter(".active").index();
		if (currentIndex < 0) currentIndex = 0;
		var autoplayInterval = null;

		// function slideToTab(index) {
		//     var $activeLink = $navLinks.eq(index);
		//     var tabLeft = $activeLink.position().left + $navTabs.scrollLeft();
		//     var containerWidth = $navTabs.parent().width();
		//     var offset = tabLeft - containerWidth/2 + $activeLink.outerWidth()/2;

		//     var maxSlide = $navTabs[0].scrollWidth - containerWidth;
		//     if (offset < 0) offset = 0;
		//     if (offset > maxSlide) offset = maxSlide;

		//     $navTabs.css('transform', 'translateX(-' + offset + 'px)');
		// }
		function slideToTab(index) {
			var $activeLink = $navLinks.eq(index);
			// Get the left position of the active tab relative to navTabs container
			var tabLeft = $activeLink.position().left + $navTabs.scrollLeft();

			// Instead of centering, make active tab align to the left
			var offset = tabLeft;

			// Prevent scrolling beyond the max scrollable width
			var maxSlide = $navTabs[0].scrollWidth - $navTabs.parent().width();
			if (offset > maxSlide) offset = maxSlide;
			if (offset < 0) offset = 0;

			$navTabs.css("transform", "translateX(-" + offset + "px)");
		}

		function goToTab(index) {
			$navLinks.removeClass("active");
			$navLinks.eq(index).addClass("active");

			$tabPanes.removeClass("show active");
			var $pane = $tabPanes.eq(index);
			$pane.addClass("show active");

			// Play Lottie animation
			var $lottie = $pane.find("lottie-player");
			if ($lottie.length) {
				$lottie[0].stop();
				$lottie[0].play();
			}

			// Slide nav for mobile
			if ($(window).width() < 992) {
				slideToTab(index);
			} else {
				$navTabs.css("transform", "none");
			}
		}

		function startAutoplay() {
			if (autoplayInterval) return;
			autoplayInterval = setInterval(function () {
				currentIndex = (currentIndex + 1) % $navLinks.length;
				goToTab(currentIndex);
			}, 5000);
		}

		function stopAutoplay() {
			if (autoplayInterval) {
				clearInterval(autoplayInterval);
				autoplayInterval = null;
			}
		}

		function handleResize() {
			if ($(window).width() < 992) {
				startAutoplay();
				goToTab(currentIndex);
			} else {
				stopAutoplay();
				$navTabs.css("transform", "none");
			}
		}

		// Click tab
		$navLinks.each(function (i) {
			$(this).on("click", function (e) {
				e.preventDefault();
				currentIndex = i;
				goToTab(currentIndex);
			});
		});

		// INIT
		goToTab(currentIndex);
		handleResize();

		$(window).on("resize", handleResize);
	});
});

const controller = new AbortController();
const signal = controller.signal;

document.addEventListener("DOMContentLoaded", function () {
	const announcementBar = document.querySelector("#site-announcement");
	const collapseAnnouncementBar = document.querySelector(
		"#collapse-announcement",
	);
	const closeAnnouncementBar = document.querySelector("#close-announcement");

	if (announcementBar && collapseAnnouncementBar && closeAnnouncementBar) {
		collapseAnnouncementBar.addEventListener(
			"click",
			function () {
				announcementBar.classList.add("collapsed");
			},
			{ signal },
		);

		closeAnnouncementBar.addEventListener(
			"click",
			function () {
				announcementBar.style.display = "none";
				controller.abort();
			},
			{ signal },
		);
	}

	let isCollapsed = true;

	window.addEventListener("scroll", () => {
		if (!announcementBar) return;

		if (window.scrollY < 100 && isCollapsed) {
			announcementBar.classList.remove("collapsed");
			isCollapsed = false;
		}

		if (window.scrollY > 100 && !isCollapsed) {
			announcementBar.classList.add("collapsed");
			isCollapsed = true;
		}
	});
});

// Step form script
document.addEventListener("DOMContentLoaded", function () {
	document.addEventListener("click", function (e) {
		if (
			e.target.classList.contains("gform_next_button") ||
			e.target.classList.contains("gform_previous_button")
		) {
			const timer = setTimeout(function () {
				const form = e.target.closest("form");
				if (form) {
					form.scrollIntoView({ behavior: "smooth", block: "end" });
				}
			}, 300);
		}
	});
});
